module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-5.6974d4e6.svg";